import Api from "../ApiUtility/Api";


class RequestOpraDS {
  constructor() {
    this.api = new Api();
  }


  WS_OPRA_Details_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OPRA_Details_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during OPRA Details API call :', error);
        throw error;
      });
  }

  
  WS_OPRA_Send_Mail(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_OPRA_Send_Mail')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during send OPRA API call :', error);
        throw error;
      });
  }

}

export default RequestOpraDS;
